import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { auditApi } from '../../services/api';

export const fetchAudit = createAsyncThunk(
  'audit/list',
  async (params, { rejectWithValue }) => {
    try {
      const res = await auditApi.list(params);
      return { items: Array.isArray(res.data) ? res.data : [], pagination: res.pagination };
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

const initialState = {
  items: [],
  status: 'idle',
  error: null,
  filters: { entity: '', action: '', admin_username: '' },
  pagination: { total: 0, page: 1, size: 50 },
};

const auditSlice = createSlice({
  name: 'audit',
  initialState,
  reducers: {
    setFilter(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetFilters(state) {
      state.filters = initialState.filters;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAudit.pending, (s) => { s.status = 'loading'; s.error = null; })
      .addCase(fetchAudit.fulfilled, (s, a) => {
        s.status = 'succeeded';
        s.items = a.payload.items;
        if (a.payload.pagination) s.pagination = a.payload.pagination;
      })
      .addCase(fetchAudit.rejected, (s, a) => { s.status = 'failed'; s.error = a.payload; });
  },
});

export const { setFilter, resetFilters } = auditSlice.actions;
export const selectAuditItems = (s) => s.audit.items;
export default auditSlice.reducer;
